import React, { useContext, useState } from 'react'
import { Context } from '../../../Store'
import { Grid, Typography, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { ErrorMessage } from './ErrorMessage'

export const Profession = () => {
  const [state, dispatch] = useContext(Context)
  const [profession, setProfession] = useState(state?.profession)
  const { t } = useTranslation()

  const professionList = [
    {
      value: 'italianStudent',
      label: t('booking.userInfo.work.italianStudent'),
    },
    {
      value: 'foreignStudent',
      label: t('booking.userInfo.work.foreignStudent'),
    },
    {
      value: 'selfEmployed',
      label: t('booking.userInfo.work.selfEmployed'),
    },
    {
      value: 'employee',
      label: t('booking.userInfo.work.employee'),
    },
  ]

  const onChangeProfession = (event) => {
    dispatch({ type: 'SET_PROFESSION', payload: event.target.value })
    setProfession(event.target.value)
  }

  return (
    <Grid item xs={12} lg={11}>
      <Typography variant="body1">{t('booking.userInfo.work.title')}</Typography>
      <FormControl fullWidth variant="outlined">
        <InputLabel name="tenant_reason">{t('booking.userInfo.work.placeholder')}</InputLabel>
          <Select
            name="profession"
            label={t('booking.userInfo.work.placeholder')}
            value={profession}
            onChange={onChangeProfession}
            error={state?.error?.profession}
          >
            {professionList.map((value) => (
              <MenuItem key={value.value} value={value.value}>
                {value.label}
              </MenuItem>
            ))}
          </Select>
      </FormControl>
      {state?.error?.profession && <ErrorMessage error={state?.error?.profession} />}
    </Grid>
  )
}